import React from 'react';
import PropTypes from 'prop-types';

import FormattedLink from '@stubhub/react-formatted-link';

class NavMultiLayerMenu extends React.Component {
  renderMenuItem = (items) => {
    const {onMenuItemClick, onOptionClick} = this.props;

    return items.map((item) =>
      item.subMenu || item.items ? (
        <div
          key={item.id}
          className="mh__nav-menu-option --sub-level"
          onClick={() => {
            onMenuItemClick && onMenuItemClick(item);
          }}
        >
          <span>{item.label}</span>
        </div>
      ) : (
        <FormattedLink
          key={item.id}
          href={item.href}
          data-item-id={item.id}
          className="mh__nav-menu-option"
          onClick={(evt) => {
            onOptionClick && onOptionClick(evt, item);
          }}
        >
          {item.label}
        </FormattedLink>
      )
    );
  };

  render() {
    const {items, menuId, prevItem, className, onMenuItemClick} = this.props;
    const navItemList = this.renderMenuItem(items);
    const categoryName = items.length ? items[0].parent : null;
    const menuLabel = items.length ? items[0].parentLabel : '';

    return (
      <div
        className={`mh__nav-multi-layer-container ${
          menuId === categoryName || menuId === 'root' ? 'active' : 'inactive'
        } ${className}`}
      >
        {menuLabel && (
          <div
            className="mh__nav-layered-menu-heading"
            onClick={() => onMenuItemClick && onMenuItemClick(prevItem, true)}
          >
            <h3>{menuLabel}</h3>
          </div>
        )}
        {navItemList}
      </div>
    );
  }
}

NavMultiLayerMenu.propTypes = {
  /** Array of menu items */
  items: PropTypes.array.isRequired,

  /** Menu id */
  menuId: PropTypes.string,

  /** Previous item */
  prevItem: PropTypes.object,

  /** Class name */
  className: PropTypes.string,

  /** Callback function when menu item is clicked */
  onMenuItemClick: PropTypes.func,

  /** Callback function when option is clicked */
  onOptionClick: PropTypes.func,
};

NavMultiLayerMenu.defaultProps = {
  menuId: '',
};

export default NavMultiLayerMenu;
